import React from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import StorageIcon from "@mui/icons-material/Storage";
import InfoIcon from "@mui/icons-material/Info";
import PeopleIcon from "@mui/icons-material/People";
import HelpIcon from "@mui/icons-material/Help";

const PREFIX = 'Drawer';

const classes = {
  root: `${PREFIX}-root`,
  list: `${PREFIX}-list`,
  fullList: `${PREFIX}-fullList`,
  drawer: `${PREFIX}-drawer`
};

const Root = styled('div')({
  [`& .${classes.root}`]: {
    display: "flex",
  },
  [`&.${classes.list}`]: {
    width: 250,
  },
  [`& .${classes.fullList}`]: {
    width: "auto",
  },
  [`& .${classes.drawer}`]: {
    zIndex: "15000 !important",
  },
});

const Drawer = () => {
  const history = useHistory();

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (side, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const topList = ["About", "Library", "Use Cases", "Help"];
  const topIcons = [
    <InfoIcon />,
    <StorageIcon />,
    <PeopleIcon />,
    <HelpIcon />,
  ];
  const topLinks = ["/about", "/library", "/usecases", "/help"];

  const bottomList = [];
  const bottomIcons = [];
  const bottomLinks = [];
  // const bottomList = ["Contact", "Questions"];
  // const bottomIcons = [<ChatIcon />, <HelpIcon />];
  // const bottomLinks = ["/about", "/about"];

  const navigateTo = (e) => {
    history.push(e.currentTarget.dataset.route);
  };

  const sideList = (side) => (
    <Root
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        {topList.map((text, index) => (
          <ListItem
            button
            alt={text}
            ariaLabel={text}
            key={text}
            data-route={topLinks[index]}
            onClick={(e) => navigateTo(e)}
          >
            <ListItemIcon>{topIcons[index]}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {bottomList.map((text, index) => (
          <ListItem
            button
            key={text}
            data-route={bottomLinks[index]}
            onClick={(e) => navigateTo(e)}
          >
            <ListItemIcon>{bottomIcons[index]}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </Root>
  );

  const fullList = (side) => (
    <div
      className={classes.fullList}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        {topList.map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {bottomList.map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      <Button onClick={toggleDrawer("left", true)}>
        <MenuIcon />
      </Button>
      <SwipeableDrawer
        className={classes.drawer}
        open={state.left}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
      >
        {sideList("left")}
      </SwipeableDrawer>
      <SwipeableDrawer
        className={classes.drawer}
        anchor="top"
        open={state.top}
        onClose={toggleDrawer("top", false)}
        onOpen={toggleDrawer("top", true)}
      >
        {fullList("top")}
      </SwipeableDrawer>
      <SwipeableDrawer
        className={classes.drawer}
        anchor="bottom"
        open={state.bottom}
        onClose={toggleDrawer("bottom", false)}
        onOpen={toggleDrawer("bottom", true)}
      >
        {fullList("bottom")}
      </SwipeableDrawer>
      <SwipeableDrawer
        className={classes.drawer}
        anchor="left"
        open={state.right}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
      >
        {sideList("left")}
      </SwipeableDrawer>
    </div>
  );
};

export default Drawer;
